import { connect } from 'react-redux';
import { parse } from 'query-string';
import store from 'js/store';
import { submitEventToValues } from 'js/helpers/form';
import { resetPassword, requestResetPassword } from 'js/store/actions/auth';
import ResetPasswordPage from '.';
export default connect(function (state) {
  var _parse = parse(state.router.location.search),
      emailVerification = _parse.emailVerification;

  var _state$authForms$requ = state.authForms.requestResetPassword,
      errorMessage = _state$authForms$requ.errorMessage,
      successMessage = _state$authForms$requ.successMessage;
  return {
    emailVerification: emailVerification,
    setPasswordIsSubmitting: state.authForms.setPassword.isSubmitting,
    resetPasswordIsSubmitting: state.authForms.requestResetPassword.isSubmitting,
    messages: {
      error: errorMessage,
      success: successMessage
    },
    resetPasswordSubmit: function resetPasswordSubmit(event) {
      var values = submitEventToValues(event);
      store.dispatch(resetPassword(values));
    },
    onRequestResetPasswordSubmit: function onRequestResetPasswordSubmit(event) {
      var values = submitEventToValues(event);
      store.dispatch(requestResetPassword(values));
    }
  };
})(ResetPasswordPage);